import React, { Component } from "react";
import axios from "../../utils/axiosInstance";

class CourierRatioChecker extends Component {
  debounceTimer = null;

  state = {
    loading: false,
    courierData: null,
    showModal: false,
  };

  componentDidMount() {
    this.debounceCheck();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.phone !== this.props.phone) {
      this.debounceCheck();
    }
  }

  debounceCheck = () => {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(this.fetchRatio, 600);
  };

  fetchRatio = async () => {
    const { phone } = this.props;
    if (!phone) return;

    this.setState({ loading: true });

    try {
      const res = await axios.get("courier/check_ratio", {
        params: { phone },
      });

      const courierData = res?.data?.response?.courierData || null;
      this.setState({ courierData, loading: false });
    } catch {
      this.setState({ courierData: null, loading: false });
    }
  };

  openModal = () => this.setState({ showModal: true });
  closeModal = () => this.setState({ showModal: false });

  render() {
    const { loading, courierData, showModal } = this.state;
    const summary = courierData?.summary;

    const ratioText = summary
      ? `${summary.success_ratio}% (${summary.total_parcel})`
      : "0.00% (0)";

    return (
      <>
        {/* ===== Ratio + Button ===== */}
        <div 
        className="d-flex align-items-center gap-2" 
        style={{ marginTop: "-3px" }}
        >
          <span className="badge bg-secondary fs-9 px-2 py-2">
            {loading ? "Checking..." : ratioText}
          </span>

          <button
            className="btn btn-sm btn-outline-primary" style={{ fontSize: "9px" }}
            onClick={this.openModal}
          >
            <span className="fs-11 px-1 py-1">
              View Details
            </span>
          </button>

        </div>

        {/* ===== Modal ===== */}
        {showModal && (
          <>
            <div className="modal fade show d-block" tabIndex="-1">
              <div className="modal-dialog modal-xl modal-dialog-centered">
                <div className="modal-content border-0 shadow">

                  {/* Header */}
                  <div className="modal-header bg-primary text-white">
                    <h5 className="modal-title">Courier Details</h5>
                    <button
                      className="btn-close btn-close-white"
                      onClick={this.closeModal}
                    />
                  </div>

                  {/* Body */}
                  <div className="modal-body">

                    {/* ❌ No Data */}
                    {!summary || summary.total_parcel === 0 ? (
                      <div className="alert alert-info text-center">
                        No courier data found for this number.
                      </div>
                    ) : (
                      <>
                        {/* ===== Summary Cards ===== */}
                        <div className="row text-center mb-4">
                          <div className="col">
                            <div className="card shadow-sm">
                              <div className="card-body">
                                <h6>Total</h6>
                                <h4>{summary.total_parcel}</h4>
                              </div>
                            </div>
                          </div>

                          <div className="col">
                            <div className="card shadow-sm bg-success text-white">
                              <div className="card-body">
                                <h6>Success</h6>
                                <h4>{summary.success_parcel}</h4>
                              </div>
                            </div>
                          </div>

                          <div className="col">
                            <div className="card shadow-sm bg-danger text-white">
                              <div className="card-body">
                                <h6>Cancelled</h6>
                                <h4>{summary.cancelled_parcel}</h4>
                              </div>
                            </div>
                          </div>

                          <div className="col">
                            <div className="card shadow-sm bg-warning">
                              <div className="card-body">
                                <h6>Ratio</h6>
                                <h4>{summary.success_ratio}%</h4>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* ===== Courier Table ===== */}
                        <div className="table-responsive">
                          <table className="table table-bordered table-hover text-center align-middle">
                            <thead className="table-dark">
                              <tr>
                                <th style={{ width: 90 }}>Logo</th>
                                <th>Courier</th>
                                <th>Total</th>
                                <th>Success</th>
                                <th>Cancelled</th>
                                <th>Ratio</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.entries(courierData)
                                .filter(([k]) => k !== "summary")
                                .map(([key, c]) => (
                                  <tr key={key}>
                                    {/* Logo */}
                                    <td>
                                      {c.logo ? (
                                        <img
                                          src={c.logo}
                                          alt={c.name}
                                          style={{
                                            height: 28,
                                            maxWidth: 80,
                                            objectFit: "contain",
                                          }}
                                        />
                                      ) : (
                                        <span className="text-muted">—</span>
                                      )}
                                    </td>

                                    {/* Name */}
                                    <td className="fw-bold">{c.name}</td>

                                    {/* Data */}
                                    <td>{c.total_parcel}</td>

                                    <td className="text-success fw-bold">
                                      {c.success_parcel}
                                    </td>

                                    <td className="text-danger fw-bold">
                                      {c.cancelled_parcel}
                                    </td>

                                    <td>
                                      <span className="badge bg-info">
                                        {c.success_ratio}%
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </>
                    )}
                  </div>

                  {/* Footer */}
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={this.closeModal}
                    >
                      Close
                    </button>
                  </div>

                </div>
              </div>
            </div>

            <div className="modal-backdrop fade show" />
          </>
        )}
      </>
    );
  }
}

export default CourierRatioChecker;
